module.exports = require("./gsw-FR.d.ts");